export const DEMO_SLACK_USER_ID = 'U1234567890'
export const isDemoAccount = (userEmail: unknown) =>
    typeof userEmail === 'string' &&
    (userEmail?.includes('@example.com') || userEmail?.includes('@acme-corp.com') || false)
